var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6474 88.5782L48.5503 90.2509C48.885 90.3623 49.1078 90.4738 49.4425 90.4738C49.7772 90.4738 50.0001 90.3623 50.3347 90.2509L54.7951 88.3554C70.7411 81.6648 81 66.2764 81 48.9923V27.3593C81 26.5789 80.5539 25.7981 79.7735 25.352L50.6694 9.85205C50.0004 9.51737 49.2195 9.51737 48.5506 9.85205L20.1155 25.4635C19.4465 25.9096 19.0004 26.5786 19.0004 27.4708V49.5499C19.0004 66.3879 29.036 81.7761 44.6474 88.5782ZM23.4605 28.6973L49.6654 14.3125L76.5393 28.6973V48.9921C76.5393 64.492 67.2838 78.3193 53.1222 84.2293L49.5541 85.7906L46.5435 84.4526C32.6047 78.431 23.5724 64.6038 23.5724 49.4384V28.6976L23.4605 28.6973Z",
    fill: "#3156FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2046 61.4812L46.8773 60.0314L66.3916 44.197L63.6038 40.7399L45.7622 55.2362L38.0683 46.2039L34.6112 49.1031L43.7552 59.8081L45.2046 61.4812Z",
    fill: "#3156FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldVerify);
export default __webpack_public_path__ + "static/media/shield-verify.13d0abe9fc9aef1afd8638e543f79d9e.svg";
export { ForwardRef as ReactComponent };